import { INVALID_PARAMETER } from '../constants/api-error-enums';
import ConsumerObject from '../schemas/dictionary/consumer-object';
import constructValidationMessage from './construct-validation-message';

/**
 * Validate the consumer object that was passed in by the PSP merchant. All keys
 * are optional per the TAD, but values for keys passed in must be the correct type
 *
 * @param {object} data - consumer object constructed and passed in by PSP merchant
 *
 * @return {object} - null if valid or an error object
 *
 */
const validateConsumerObject = data => {
  const { error } = ConsumerObject.validate(data, {
    abortEarly: false,
    allowUnknown: true // TODO: should we allow other keys?
  });

  let reason;
  if (error) {
    reason = INVALID_PARAMETER;
  }

  return constructValidationMessage(error, 'consumerObject', reason);
};

export default validateConsumerObject;
